import React from 'react'
import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import ButtonBase from '@material-ui/core/ButtonBase'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import { GoogleAuthProvider, User, signInWithPopup } from 'firebase/auth'
import { useUser, useAuth } from 'reactfire'

interface LoginProps {
  open: boolean
  handleOpen: () => void
  handleClose: () => void
  fbUser: User | null
  loginWithGoogle: () => Promise<void>
  isFirebaseLoaded: () => boolean
  isFirebaseEmpty: () => boolean
  isLoggedIn: () => boolean
  logout: () => Promise<void>
}

const initLoginProps: LoginProps = {
  open: false,
  handleOpen: () => {},
  handleClose: () => {},
  fbUser: null,
  loginWithGoogle: async () => {},
  isFirebaseLoaded: () => false,
  isFirebaseEmpty: () => true,
  isLoggedIn: () => false,
  logout: async () => {}
}

const LoginContext = React.createContext<LoginProps>(initLoginProps)

export const LoginProvider: React.FC = ({ children }) => {
  const provider = new GoogleAuthProvider()
  const auth = useAuth()

  // Firebase
  const user = useUser<null>()
  const fbUser = React.useMemo(() => user.data, [user.data])
  const isFirebaseLoaded = () => true
  const isFirebaseEmpty = () => fbUser === null
  const isLoggedIn = () => !isFirebaseEmpty() && isFirebaseLoaded()
  const loginWithGoogle = async () => {
    await signInWithPopup(auth, provider)
  }
  const logout = async () => {
    await auth.signOut()
  }

  // Dialog
  const [open, setOpen] = React.useState(initLoginProps.open)
  const handleOpen = () => {
    setOpen(true)
  }
  const handleClose = () => {
    setOpen(false)
  }

  return (
    <LoginContext.Provider
      value={{
        open,
        handleOpen,
        handleClose,
        fbUser,
        loginWithGoogle,
        isFirebaseLoaded,
        isFirebaseEmpty,
        isLoggedIn,
        logout
      }}
    >
      {children}
    </LoginContext.Provider>
  )
}

export const useLogin = () => React.useContext(LoginContext)

const Component: React.VFC = () => {
  const { open, handleClose, loginWithGoogle } = useLogin()

  const handleLogin = async () => {
    await loginWithGoogle()
    handleClose()
  }
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">Sign in with Google</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          Sign in with a Google account to add papers to the database.
        </DialogContentText>
        <Box onClick={handleLogin} style={{ textAlign: 'center' }}>
          <ButtonBase>
            <img alt="signin" src="/images/google_signin_buttons/btn_google_signin_dark_normal_web.png" width="191" />
          </ButtonBase>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default Component
